// src/components/LoadingScreen.js
import React from 'react';
import PropTypes from 'prop-types';

function LoadingScreen({ message = 'Cargando...', fullScreen = true, size = 'md' }) {
  const sizeMap = {
    sm: { width: '1.5rem', height: '1.5rem', borderWidth: '0.2rem' },
    md: { width: '2.5rem', height: '2.5rem', borderWidth: '0.3rem' },
    lg: { width: '4rem', height: '4rem', borderWidth: '0.4rem' }
  };

  const { width, height, borderWidth } = sizeMap[size] || sizeMap.md;

  return (
    <div className={`d-flex justify-content-center align-items-center ${fullScreen ? 'vh-100 w-100' : ''} bg-light`}>
      <div className="text-center">
        <div 
          className="spinner-border text-primary" 
          style={{ width, height, borderWidth }}
          role="status"
        >
          <span className="visually-hidden">Cargando...</span>
        </div>
        {message && (
          <p className="mt-3 text-muted">
            {message}
            <span className="loading-dots">...</span>
          </p>
        )}
      </div>
      
      <style jsx="true">{`
        @keyframes dots {
          0%, 20% { content: ''; }
          40% { content: '.'; }
          60% { content: '..'; }
          80%, 100% { content: '...'; }
        }
        
        .loading-dots::after {
          content: '';
          animation: dots 1.5s steps(1, end) infinite;
        }
      `}</style>
    </div>
  );
}

LoadingScreen.propTypes = {
  message: PropTypes.string,
  fullScreen: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
};

export default LoadingScreen;
